import { render, staticRenderFns } from "./choose-product.vue?vue&type=template&id=62e4658d&"
import script from "./choose-product.vue?vue&type=script&lang=js&"
export * from "./choose-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports